import { render } from "./TicketResult.vue?vue&type=template&id=4b62ce11&scoped=true"
import script from "./TicketResult.vue?vue&type=script&lang=js"
export * from "./TicketResult.vue?vue&type=script&lang=js"

import "./TicketResult.vue?vue&type=style&index=0&id=4b62ce11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b62ce11"]])

export default __exports__